const formatPercentage = (number: number, maximumFractionDigits = 2) => {
  const formatter = new Intl.NumberFormat('nl-NL', {
    maximumFractionDigits,
    style: 'percent',
  }).format

  return formatter(number)
}

export default formatPercentage
